import { z } from 'zod';
import { MoneySchema, QuantitySchema } from '../../../domain/shared/types';

export const UpdateProductDTOSchema = z.object({
  name: z.string().min(1, 'Product name is required').optional(),
  sku: z.string().min(1, 'SKU is required').optional(),
  description: z.string().optional(),
  barcode: z.string().optional(),
  category: z.string().optional(),
  cost: MoneySchema.optional(),
  price: MoneySchema.optional(),
  minQuantity: QuantitySchema.optional(),
  maxQuantity: QuantitySchema.optional(),
  isActive: z.boolean().optional()
});

export interface UpdateProductDTO {
  name?: string;
  sku?: string;
  description?: string;
  barcode?: string;
  category?: string;
  cost?: {
    amount: number;
    currency: string;
  };
  price?: {
    amount: number;
    currency: string;
  };
  minQuantity?: {
    value: number;
    unit: string;
  };
  maxQuantity?: {
    value: number;
    unit: string;
  };
  isActive?: boolean;
}
